import { useCallback } from 'react';

import { useTracking as useTrackingBase } from '@change-corgi/core/react/tracking';

import { usePromotePageData, usePromotePageState } from 'src/app/pages/promote/pageContext';

type Result = {
	trackAmountTooHighView: () => void;
	trackAmountTooHighCancel: () => void;
	trackAmountTooHighConfirm: () => void;
};

export function useTracking(): Result {
	const track = useTrackingBase();

	const {
		data: {
			promotionCountrySettings: { confirmationAmount },
		},
	} = usePromotePageData();

	const [{ amount }] = usePromotePageState();

	return {
		trackAmountTooHighView: useCallback(() => {
			void track('pp_amount_too_high_view', {
				amount,
				confirmation_amount: confirmationAmount || undefined,
			});
		}, [amount, confirmationAmount, track]),

		trackAmountTooHighCancel: useCallback(() => {
			void track('pp_amount_too_high_cancel', {
				amount,
				confirmation_amount: confirmationAmount || undefined,
			});
		}, [amount, confirmationAmount, track]),

		trackAmountTooHighConfirm: useCallback(() => {
			void track('pp_amount_too_high_confirm', {
				amount,
				confirmation_amount: confirmationAmount || undefined,
			});
		}, [amount, confirmationAmount, track]),
	};
}
